import { useMediaQuery } from '@mui/material';
import mainTheme from '../assets/styles/themes/mainTheme';
import useRouter from './useRouter';
import { routes } from '../constants';

export const useIsSidebarCollapsed = () => {  
  const { match: { location: { pathname } } } = useRouter();
  const isReaderPage = pathname.includes(`/${routes.reader.root}/`);
  const isSidebarCollapsed = 
    useMediaQuery(mainTheme.breakpoints.down('collapsedSideNavbar'), { noSsr: true })
    || isReaderPage;
  return isSidebarCollapsed;
};
